module.exports = __webpack_public_path__ + "static/media/home-back-mobile.aab83ccd.png";